export default __webpack_public_path__ + "static/media/SecureFile_Clients.9005ddc5.png";